import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { PublicDictionaryProductAttributeResponse } from '@web/shared/module/dictionary';

@jsonObject
export class PublicProductAttributeResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly value!: string;

  @jsonMember(PublicDictionaryProductAttributeResponse)
  public readonly productAttribute!: PublicDictionaryProductAttributeResponse;
}
